export default {
  user: {},
  item: {},
  list: [],
};
